import { useApiClient } from "../../../hooks/useApiClient";
import useSWR from "swr";
import {
  type ICommercialMonitoringNotificationsResponse,
  type ICommercialMonitoringNotificationsObject,
} from "../types";

// 異動通知の再検証間隔。インポート完了・異動反映を拾うためのポーリング周期
const NOTIFICATION_REFRESH_INTERVAL_MS = 30_000;
// フォーカス復帰と定期再検証が近接した際の重複リクエストを抑える間隔
const NOTIFICATION_DEDUPING_INTERVAL_MS = 5_000;

interface IResponse {
  data: ICommercialMonitoringNotificationsObject[];
  isLoading: boolean;
}

export const useCommercialMonitoringNotifications = (): IResponse => {
  const { apiClient } = useApiClient();

  // swrに引き渡すfetcher
  const fetcher = async (
    url: string
  ): Promise<ICommercialMonitoringNotificationsResponse> => {
    const { data } =
      await apiClient.get<ICommercialMonitoringNotificationsResponse>(url);
    return data;
  };

  const toObjectList = (
    data: ICommercialMonitoringNotificationsResponse | undefined
  ): ICommercialMonitoringNotificationsObject[] => {
    if (data === undefined) return [];
    return data.list;
  };

  const { data: notifications, isLoading } = useSWR(
    "/commercial-monitoring/notification",
    fetcher,
    {
      revalidateOnFocus: true,
      refreshInterval: NOTIFICATION_REFRESH_INTERVAL_MS,
      dedupingInterval: NOTIFICATION_DEDUPING_INTERVAL_MS,
    }
  );

  return { data: toObjectList(notifications), isLoading };
};
